(() => {
  console.log("Shop Mega: Script Loaded v5 (Content Links Ignored)");

  const getOverlay = () => document.querySelector(".shop-mega-overlay");
  
  // LOGIC: Is this the Main "Shop" Button?
  const isHeaderShopTrigger = (element) => {
    if (!element) return false;

    // 1. IGNORE links inside the Mega Menu itself
    if (element.closest(".shop-mega-panel")) return false;

    // 2. IGNORE links inside the Main Page Content 
    // (This fixes the issue on your Shop page "Shop by Collection" section)
    if (element.closest("#MainContent, .main-content, .shopify-section--apps")) return false;

    // 3. Check for explicit trigger attribute (Best method)
    if (element.getAttribute("data-shop-mega-trigger") === "true") return true;

    // 4. Fallback: Check Text or Href
    const text = (element.innerText || "").trim().toLowerCase();
    const href = (element.getAttribute("href") || "").toLowerCase();
    
    // Logic: It says "Shop" OR points to /collections
    if (text === "shop" || href === "/shop" || href.includes("/collections")) {
        return true;
    }

    return false;
  };

  // TOGGLE FUNCTION
  const toggleMega = (forceState) => {
    const overlay = getOverlay();
    if (!overlay) return;

    const isActive = overlay.classList.contains("is-active");
    const shouldOpen = forceState !== undefined ? forceState : !isActive;

    if (shouldOpen) {
      overlay.classList.add("is-active");
      document.body.style.overflow = "hidden"; // Lock scroll
    } else {
      overlay.classList.remove("is-active");
      document.body.style.overflow = ""; // Unlock scroll
    }
  };

  // MAIN LISTENER
  document.addEventListener("click", (e) => {
    // 1. Close Button Logic
    if (e.target.closest(".shop-mega-close") || e.target.classList.contains("shop-mega-wrap")) {
      e.preventDefault();
      toggleMega(false);
      return;
    }

    // 2. Find the closest link
    const link = e.target.closest("a, button");
    if (!link) return;

    // 3. HIJACK CHECK: Is this the "Shop" button?
    if (isHeaderShopTrigger(link)) {
      const overlay = getOverlay();
      
      if (!overlay) return; 

      e.preventDefault();
      e.stopPropagation();
      toggleMega(true);
    }
  }, true);

  // Close on Escape Key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") toggleMega(false);
  });

})();